export const stripShortcodes = (content) => {
  if (!content) return '';
  return content.replace(/\[\/?[\w_-]+(?:\s+[^\]]*)?\]/g, '').trim();
}
